import { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaHeart, FaRegHeart, FaMapMarkerAlt } from "react-icons/fa";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { useNavigate } from "react-router-dom";


export default function Wishlist() {
    const [wishlist, setWishlist] = useState([]);
    const navigate = useNavigate();

    const removeFromWishlist = (id) => {
        const updated = wishlist.filter(item => item.id !== id);
        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("wishlist")) || [];
        setWishlist(stored);
    }, []);

    return (
        <div>
            <Hero
                heightClass="h-[180px] sm:h-[230px] md:h-[250px] lg:h-[200px]"
                title="Wishlist"
                backgroundImage={heroImg}
                contentClass=""
            />

            <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">

                <h2 className="text-2xl sm:text-3xl font-bold text-[#FF6B35] mb-6 sm:mb-8 flex items-center gap-2">
                    My Wishlist
                    <svg
                        className="w-4 h-4 bg-pink-50 text-pink-600 w-7 h-7"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        />
                    </svg>
                </h2>

                {wishlist.length === 0 ? (
                    <p className="text-gray-500 text-sm sm:text-base">
                        No hotels in wishlist
                    </p>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        {wishlist.map((hotel) => (
                            <div
                                key={hotel.id}
                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl hover:ring-2 hover:ring-[#FF6B35] transition-all duration-300 transform hover:-translate-y-2"
                            >
                                {/* Image Section */}
                                <div className="relative h-48 sm:h-52 md:h-56 w-full overflow-hidden">
                                    <img
                                        src={`https://dubaicheaphotels.com/uploads/hotels/${hotel.image}`}
                                        alt={hotel.name}
                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                    />

                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            removeFromWishlist(hotel.id);
                                        }}
                                        className="absolute top-3 right-3 bg-white/90 p-2 rounded-full shadow hover:scale-110 transition"
                                    >
                                        <FaHeart className="text-red-500" />
                                    </button>

                                    <div className="absolute top-3 left-3 bg-white/90 text-gray-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold shadow flex items-center gap-1">
                                        ⭐ 4.5
                                        <span className="text-yellow-600 text-[10px] sm:text-xs font-medium">
                                            Excellent (120)
                                        </span>
                                    </div>

                                    <div className="absolute bottom-3 right-3 bg-[#FF6B35] text-white px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-bold shadow">
                                        {Math.round(hotel.price_per_night)} AED / night
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="p-4 sm:p-5">
                                    <h3 className="text-lg sm:text-xl font-semibold text-gray-800 group-hover:text-[#FF6B35] transition">
                                        {hotel.name}
                                    </h3>

                                    <p className="text-xs sm:text-sm text-gray-500 mt-1 flex items-center gap-1">
                                        <FaMapMarkerAlt className="text-[#FF6B35]" />
                                        {hotel.location || "Dubai, UAE"}
                                    </p>

                                    <div className="border-t my-2 sm:my-3"></div>

                                    {/* <p className="text-xs sm:text-sm text-gray-600 line-clamp-2">
                                        {hotel.description}
                                    </p> */}

                                    <p className="text-slate-600 text-sm mt-4 leading-6 line-clamp-2 min-h-[48px]">
                                        {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                    </p>

                                    <button className="mt-4 sm:mt-5 w-full bg-[#FF6B35] hover:bg-[#e85a2a] text-white py-2 rounded-lg text-sm sm:text-base font-medium transition">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}